import Icon from "../Icon";
import { PJ_NODOS } from "../../constants";
import { etiquetaTecla } from "./atajos";

// Barra del lienzo.
//
// Criterio: area de pulsacion grande y aspecto sobrio. Antes eran botones de
// 12 px de icono con 6 px de padding, casi todos sin texto: bonitos y dificiles
// de acertar, sobre todo los de insertar, que es lo que mas se usa.
//
// Ahora cada boton mide 30 px de alto como minimo, los de insertar llevan su
// nombre escrito, y el atajo se ve en el propio boton en vez de estar escondido
// en el title. Nada de degradados ni colores de acento salvo para marcar estado.
const ALTO = 30;

function Btn({ ic, label, atajo, title, onClick, disabled, ancho, activo }) {
  return (
    <button className={"df-btn" + (activo ? " on" : "")} onClick={onClick} disabled={disabled}
      title={[title, atajo ? `(${etiquetaTecla(atajo)})` : null].filter(Boolean).join(" ")}
      style={{ minHeight: ALTO, minWidth: label ? undefined : ALTO, width: ancho }}>
      <Icon name={ic} size={13} color="currentColor" />
      {label && <span>{label}</span>}
      {label && atajo && <kbd className="df-kbd">{etiquetaTecla(atajo)}</kbd>}
    </button>
  );
}

export default function FlowToolbar({
  editable, guardando, zoom, puedeDeshacer, puedeRehacer, nodos, atajos = {},
  conectando,
  onAñadir, onDeshacer, onRehacer, onZoom, onEncajar, onAutoOrganizar, onAtajos,
  onConectar,
}) {
  return (
    <>
      <div className="df-bar">
        {editable && (
          <>
            <span className="df-bar-tit">Insertar</span>
            {PJ_NODOS.map(n => (
              <Btn key={n.key} ic={n.icon} label={n.label}
                atajo={atajos[`nodo:${n.key}`]}
                title={`Añadir ${n.label.toLowerCase()}`}
                onClick={() => onAñadir(n.key)} />
            ))}
            {/* Conectar sin arrastrar: pulsar ARMA una flecha desde el paso
                señalado —el que esta bajo el cursor, o el seleccionado— y
                despues se pulsa el destino. El boton se queda marcado mientras
                espera, que es lo que hace evidente que el editor esta en medio
                de algo.
                Dos botones y no uno con modificador: la rama opcional se usa
                tanto como la principal y esconderla tras una tecla la haria
                invisible. */}
            <span className="df-bar-sep" />
            <span className="df-bar-tit">Conectar</span>
            <Btn ic="arrow-right-short" label="Rama"
              atajo={atajos["conectar:normal"]} activo={conectando === "normal"}
              title="Arma una flecha desde el paso señalado; despues pulsa el destino"
              onClick={() => onConectar?.(false)} />
            <Btn ic="dash-lg" label="Opcional"
              atajo={atajos["conectar:opcional"]} activo={conectando === "opcional"}
              title="Igual, pero como rama opcional (se pinta punteada)"
              onClick={() => onConectar?.(true)} />

            <span className="df-bar-sep" />
            <Btn ic="arrow-counterclockwise" title="Deshacer" atajo="Ctrl+Z"
              onClick={onDeshacer} disabled={!puedeDeshacer} />
            <Btn ic="arrow-repeat" title="Rehacer" atajo="Ctrl+Shift+Z"
              onClick={onRehacer} disabled={!puedeRehacer} />
            <Btn ic="diagram-3" title="Reorganizar el diagrama"
              atajo={atajos.organizar} onClick={onAutoOrganizar} disabled={!nodos} />
            <span className="df-bar-sep" />
            {/* La tuerca, que es lo que significa "configurar" en el resto de la
                app. Antes esto llevaba `sliders`, que es el icono del nodo
                switch: el mismo dibujo para insertar un nodo y para abrir los
                ajustes hacia dudar de los dos. */}
            <Btn ic="gear" title="Configurar los atajos de teclado"
              onClick={onAtajos} />
          </>
        )}
        {!editable && (
          <span className="df-bar-tit" style={{ padding: "0 6px" }}>Solo lectura</span>
        )}
      </div>

      <div className="df-zoom">
        <Btn ic="zoom-in"  title="Acercar" atajo="+" onClick={() => onZoom(1.2)} />
        <Btn ic="zoom-out" title="Alejar"  atajo="-" onClick={() => onZoom(1 / 1.2)} />
        <Btn ic="arrows-fullscreen" title="Ver todo" atajo={atajos.encajar}
          onClick={onEncajar} />
      </div>

      {/* Solo el tamaño. Antes llevaba tambien las instrucciones de uso, pero
          una ayuda fija se lee una vez y despues es ruido permanente ocupando
          el borde del lienzo. Lo unico que se mantiene es el aviso de guardado,
          porque no es una instruccion: aparece solo mientras hay algo sin
          guardar y desaparece al terminar. */}
      <div className="df-hint">
        {conectando
          ? <span style={{ color: conectando === "opcional" ? "#8b5cf6" : "var(--accent)" }}>
              Pulsa el paso de destino · Esc para cancelar
            </span>
          : guardando
            ? <span style={{ color: "var(--accent)" }}>Guardando…</span>
            : <span className="df-hint-zoom">{Math.round(zoom * 100)}%</span>}
      </div>
    </>
  );
}
